const SideMenu = {
  $: 'Stack',
  props: {
    width: '100%',
    direction: 'column',
    fontSize: 'lg',
    spacing: 0,
    px: [4, null, null, 10],
  },
};

export default SideMenu;
